import { create } from "zustand";

type AppState = {
  selectedDepartmentId: string | null;
  setSelectedDepartmentId: (id: string | null) => void;
};

export const useAppStore = create<AppState>((set) => ({
  selectedDepartmentId: null,
  setSelectedDepartmentId: (id) => set({ selectedDepartmentId: id }),
}));
